'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ValidationService.$inject = ['ValidationConstants'];


var _module = _angular2.default.module('cb.core.forms.ValidationService', []);

_module.factory('ValidationService', ValidationService);

exports.default = _module;


function ValidationService(ValidationConstants) {

    return {
        validateZipcode: function validateZipcode(value) {
            return ValidationConstants.REGEX_ZIPCODE.test(value);
        },
        validateLicenseplate: function validateLicenseplate(value) {
            var valid = false;

            _angular2.default.forEach(ValidationConstants.REGEX_LICENSEPLATE, function (regex) {
                if (regex.test(value)) {
                    valid = true;
                }
            });

            return valid;
        },
        validateBsn: function validateBsn(value) {
            return ValidationConstants.REGEX_BSN.test(value);
        },
        validateElfproef: function validateElfproef(value) {
            var total = 0;
            var j = value.length;
            for (var i = 0; i < value.length; i++) {
                total += value.charAt(i) * j;
                j -= 1;
            }
            if (total % 11 !== 0) {
                return false;
            }

            return true;
        },
        validatePhonenumber: function validatePhonenumber(value) {
            return ValidationConstants.REGEX_PHONE.test(value);
        },
        validateMobilePhonenumber: function validateMobilePhonenumber(value) {
            return ValidationConstants.REGEX_PHONE_MOBILE.test(value);
        },
        validateParelPhonenumber: function validateParelPhonenumber(value) {
            return ValidationConstants.REGEX_PHONE_PAREL.test(value);
        },
        validateEmail: function validateEmail(value) {
            return ValidationConstants.REGEX_EMAIL.test(value);
        },
        validateParelEmail: function validateParelEmail(value) {
            return ValidationConstants.REGEX_EMAIL_PAREL.test(value);
        },
        validateUrl: function validateUrl(value) {
            return ValidationConstants.REGEX_URL.test(value);
        },
        validateInitials: function validateInitials(value) {
            return ValidationConstants.REGEX_INITIALS.test(value);
        },
        validateLastName: function validateLastName(value) {
            return ValidationConstants.REGEX_LASTNAME.test(value);
        },
        validateInteger: function validateInteger(value) {
            return ValidationConstants.REGEX_INTEGER.test(value);
        },
        validateAlpha: function validateAlpha(value) {
            return ValidationConstants.REGEX_ALPHA.test(value);
        },
        validateAlphanum: function validateAlphanum(value) {
            return ValidationConstants.REGEX_ALPHANUM.test(value);
        },
        validateParelAlphanum: function validateParelAlphanum(value) {
            return ValidationConstants.REGEX_ALPHANUM_PAREL.test(value);
        },
        validateNumeric: function validateNumeric(value) {
            return ValidationConstants.REGEX_NUMERIC.test(value);
        },
        validateNoSpaces: function validateNoSpaces(value) {
            return ValidationConstants.REGEX_NO_SPACES.test(value);
        },
        validateNoPunctuation: function validateNoPunctuation(value) {
            return ValidationConstants.REGEX_NO_PUNCTUATION.test(value);
        },
        validateNoDiacritics: function validateNoDiacritics(value) {
            return ValidationConstants.REGEX_NO_DIACRITICS.test(value);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/validation/validation.service.js
// module id = 799
// module chunks = 0